import script from "./PaperPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaperPreview.vue?vue&type=script&lang=ts&setup=true"

import "./PaperPreview.vue?vue&type=style&index=0&id=1889d2f2&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1889d2f2"]])

export default __exports__